import { useAppQuery } from "~/hooks/useAppQuery"
import { getUnreadCount } from "../server/profile.functions"

export const unreadCountQueryKey = ["home", "profile", "unread-count"] satisfies readonly ["home", "profile", "unread-count"]

export function useUnreadCount() {
  return useAppQuery({
    queryKey: unreadCountQueryKey,
    queryFn: () => getUnreadCount(),
    errorMessage: "Не удалось загрузить уведомления",
  })
}
